import React from 'react'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { OrganisationType, TradingEntity, TradingRelationshipDetail, WorkflowActions } from 'api'
import { AgGridWrapper } from 'view/components/datagrid'
import { Locale, Translation } from 'locale'
import { ModalConsumerProps, withModal } from 'view/shared/modal'
import {
  tradingEntityRelationshipsGridOptions,
  tradingEntityRelationshipsPanelColumnDefs
} from './TradingEntityRelationshipsPanelGridModel'
import { tradingRelationshipDetailsByTradingEntityIdGetterSelector } from 'selectors/tradingRelationshipSelectors'
import { GridHeader, Wrapper } from './TradingEntityRelationshipPanelStyled'

interface ViewTradingRelationshipsPanelProps extends ModalConsumerProps {
  // Own Props
  tradingEntity: TradingEntity
  organisationType: OrganisationType

  // State Props
  getTradingRelationshipDetails: (tradingEntityId: string, organisationType: OrganisationType) => TradingRelationshipDetail[] | null
}

const mapStateToProps = createStructuredSelector({
  getTradingRelationshipDetails: tradingRelationshipDetailsByTradingEntityIdGetterSelector
})

const mapDispatchToProps = {
  addNewTradingEntityRelationship: WorkflowActions.createAddToExistingWorkflow
}

const ViewTradingEntityRelationshipsPanelComponent: React.FunctionComponent<ViewTradingRelationshipsPanelProps> = props => {
  const { tradingEntity, organisationType, getTradingRelationshipDetails } = props

  const tradingRelationshipDetails = getTradingRelationshipDetails(tradingEntity.id, organisationType)

  if (!tradingRelationshipDetails) {
    return null
  }

  const noTradingEntityRelationshipsPlaceholder = () => <div>{Locale.translate(Translation.SC_NO_TRADING_ENTITY_RELATIONSHIPS)}</div>

  return (
    <Wrapper>
      <GridHeader>
        <label>{Locale.translate(Translation.TC_TRADING_ENTITY_RELATIONSHIPS)}</label>
      </GridHeader>
      <AgGridWrapper
        className="datagrid-borderless"
        gridOptions={tradingEntityRelationshipsGridOptions}
        columnDefs={tradingEntityRelationshipsPanelColumnDefs}
        rowData={tradingRelationshipDetails}
        placeholder={noTradingEntityRelationshipsPlaceholder}
      />
    </Wrapper>
  )
}

export const ViewTradingEntityRelationshipsPanel = withModal(
  connect(mapStateToProps, mapDispatchToProps)(ViewTradingEntityRelationshipsPanelComponent)
)
